
import { computed, defineComponent, PropType } from 'vue'
import { HistoryRecord, KeyMapper } from '@/modules/_shared/audit-log/types'
import { useAuditLogModule } from '@/modules/_shared/audit-log'
import AuditLogActivityMessageField from '@/components/employees-audit-log/activity-message-field.vue'
import { mapper } from '@/modules/_shared/audit-log/key-mapper'
import AuditLogOperatorLink from '@/components/employees-audit-log/operator-link.vue'

export default defineComponent({
    name: 'audit-log-resource-history',
    components: {
        AuditLogOperatorLink,
        AuditLogActivityMessageField
    },
    props: {
        history: {
            type: Array as PropType<HistoryRecord[]>,
            required: true
        },
        keyMapper: {
            type: Object as PropType<KeyMapper>
        }
    },
    setup (props) {
        const {
            toReadableActivities,
            aliasForAction
        } = useAuditLogModule()
        const columns = ([
            {
                name: 'actionName',
                label: 'Action name',
                field: 'actionName',
                align: 'left'
            },
            {
                name: 'message',
                label: 'Message',
                field: 'message',
                align: 'left'
            },
            {
                name: 'operator',
                label: 'Performed by',
                field: 'operator',
                align: 'left'
            },
            {
                name: 'occurrence',
                label: 'Occurrence',
                field: 'occurrence',
                align: 'left'
            }
        ])

        return {
            columns,
            aliasForAction,
            keyMapperInstance: props.keyMapper || mapper(),
            items: computed(() => toReadableActivities(props.history))
        }
    }
})
